import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-attached-file-mandatory-message',
  templateUrl: './attached-file-mandatory-message.component.html',
  styleUrls: ['./attached-file-mandatory-message.component.scss']
})
export class AttachedFileMandatoryMessageComponent implements OnInit {

  @Input() message: string = 'Por favor completar los datos obligatorios indicados';
  @Input() icon: string = 'pi-times-circle';

  constructor() { }

  ngOnInit(): void {
  }

}
